const wizardBuildI18n = {
  en: {
    'wizard.build_reading_brief': 'Maestro is reading your brief',
    'wizard.build_choosing_territory': 'Choosing territory — {count} artists',
    'wizard.build_finding_tracks': 'Finding tracks — {current} of {target} · {eta}',
    'wizard.build_building': 'Maestro is building your playlist…',
    'wizard.build_still_shaping': 'Still building your playlist — tracks will appear as they\'re ready…',
    'wizard.playing_while_finishing': 'Playing while Maestro finishes',
  },
  es: {
    'wizard.build_reading_brief': 'Maestro está leyendo tu descripción',
    'wizard.build_choosing_territory': 'Eligiendo territorio — {count} artistas',
    'wizard.build_finding_tracks': 'Buscando pistas — {current} de {target} · {eta}',
    'wizard.build_building': 'Maestro está creando tu playlist…',
    'wizard.build_still_shaping': 'Aún creando tu playlist — las pistas aparecerán cuando estén listas…',
    'wizard.playing_while_finishing': 'Reproduciendo mientras Maestro termina',
  },
  fr: {
    'wizard.build_reading_brief': 'Maestro lit votre brief',
    'wizard.build_choosing_territory': 'Choix du territoire — {count} artistes',
    'wizard.build_finding_tracks': 'Recherche de titres — {current} sur {target} · {eta}',
    'wizard.build_building': 'Maestro crée votre playlist…',
    'wizard.build_still_shaping': 'Création de la playlist en cours — les titres apparaîtront au fil de l\'eau…',
    'wizard.playing_while_finishing': 'Lecture pendant que Maestro termine',
  },
  de: {
    'wizard.build_reading_brief': 'Maestro liest Ihr Briefing',
    'wizard.build_choosing_territory': 'Territorium wählen — {count} Künstler',
    'wizard.build_finding_tracks': 'Titel suchen — {current} von {target} · {eta}',
    'wizard.build_building': 'Maestro erstellt Ihre Playlist…',
    'wizard.build_still_shaping': 'Playlist wird noch erstellt — Titel erscheinen, sobald sie bereit sind…',
    'wizard.playing_while_finishing': 'Wiedergabe, während Maestro fertigstellt',
  },
  it: {
    'wizard.build_reading_brief': 'Maestro sta leggendo il tuo brief',
    'wizard.build_choosing_territory': 'Scelta del territorio — {count} artisti',
    'wizard.build_finding_tracks': 'Ricerca brani — {current} di {target} · {eta}',
    'wizard.build_building': 'Maestro sta creando la tua playlist…',
    'wizard.build_still_shaping': 'Creazione playlist in corso — i brani appariranno man mano…',
    'wizard.playing_while_finishing': 'In riproduzione mentre Maestro termina',
  },
  pt: {
    'wizard.build_reading_brief': 'Maestro está a ler o seu briefing',
    'wizard.build_choosing_territory': 'A escolher território — {count} artistas',
    'wizard.build_finding_tracks': 'A encontrar faixas — {current} de {target} · {eta}',
    'wizard.build_building': 'Maestro está a criar a sua playlist…',
    'wizard.build_still_shaping': 'Ainda a criar a playlist — as faixas aparecem à medida que ficam prontas…',
    'wizard.playing_while_finishing': 'A reproduzir enquanto Maestro termina',
  },
  ja: {
    'wizard.build_reading_brief': 'Maestro がブリーフを読んでいます',
    'wizard.build_choosing_territory': 'テリトリーを選んでいます — {count} アーティスト',
    'wizard.build_finding_tracks': 'トラックを探しています — {current} / {target} · {eta}',
    'wizard.build_building': 'Maestro がプレイリストを作成しています…',
    'wizard.build_still_shaping': 'プレイリスト作成中 — 曲は準備でき次第表示されます…',
    'wizard.playing_while_finishing': 'Maestro の仕上げ中も再生中',
  },
  ko: {
    'wizard.build_reading_brief': 'Maestro가 요청을 읽고 있습니다',
    'wizard.build_choosing_territory': '영역 선택 중 — 아티스트 {count}명',
    'wizard.build_finding_tracks': '트랙 찾는 중 — {current} / {target} · {eta}',
    'wizard.build_building': 'Maestro가 플레이리스트를 만드는 중…',
    'wizard.build_still_shaping': '플레이리스트 생성 중 — 준비되는 대로 트랙이 표시됩니다…',
    'wizard.playing_while_finishing': 'Maestro가 마무리하는 동안 재생 중',
  },
  zh: {
    'wizard.build_reading_brief': 'Maestro 正在阅读您的描述',
    'wizard.build_choosing_territory': '选择音乐领域 — {count} 位艺术家',
    'wizard.build_finding_tracks': '正在寻找曲目 — {current} / {target} · {eta}',
    'wizard.build_building': 'Maestro 正在创建您的播放列表…',
    'wizard.build_still_shaping': '仍在创建播放列表 — 曲目就绪后将陆续出现…',
    'wizard.playing_while_finishing': 'Maestro 完成前即可播放',
  },
  nl: {
    'wizard.build_reading_brief': 'Maestro leest je briefing',
    'wizard.build_choosing_territory': 'Territorium kiezen — {count} artiesten',
    'wizard.build_finding_tracks': 'Tracks zoeken — {current} van {target} · {eta}',
    'wizard.build_building': 'Maestro bouwt je playlist…',
    'wizard.build_still_shaping': 'Playlist wordt nog gebouwd — tracks verschijnen zodra ze klaar zijn…',
    'wizard.playing_while_finishing': 'Afspelen terwijl Maestro afrondt',
  },
};

export default wizardBuildI18n;
